import $ from 'jquery';
import { Controller } from "@hotwired/stimulus";
import { disp_xhr_error} from '../jssrc/ui_tweak.js';
import i18n from '../jssrc/i18n_js_with_locales.js';

export default class extends Controller {
    static targets = [ "country", "state", "remoteJob", "locationRequirements" ]

    connect(){
		let country_field = $(this.countryTarget);
		country_field.select2({width: '100%'});

        let alrs_field = $('#alrs #alrs-list');
        alrs_field.select2({width: '100%'})

		let that = this;
		country_field.on("change", function (e) {
			that.fetch_states(this.value);
		});
		this.enable_remote_job();
    }

    on_post_success(event){
		$.jqmodal.close();
		alert(i18n.t("openings.publish.publish_succ"));
    }

    on_post_error(event){
		const [, , xhr] = event.detail;
		disp_xhr_error(this, xhr);
    }

    enable_remote_job(){
        let disp_style = this.remoteJobTarget.checked == true? 'block': 'none';
        document.getElementById('alrs').style.display = disp_style;
    }

    build_state_options(states){
		let frag = document.createDocumentFragment(), opt;
		frag.appendChild(document.createElement('option'));

		for (const state of states) {
			opt = frag.appendChild(document.createElement('option'));
			opt.value = state[0];
			opt.text = state[1];
		}
		this.stateTarget.replaceChildren(frag);
    }

    fetch_states() {
		fetch('/drop_lists/STATE/?country=' + this.countryTarget.value, {method: 'GET'})
			.then(response => response.json())
			.then(data => this.build_state_options(data));
    }
}
